import React from "react"
import { Input } from "antd"
import { useTranslation } from "react-i18next"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"
import styles from "../index.module.css"

export const TemplateForm = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.questionCard}>
      <LabeledField
        labelKey="settings.template_labels_name"
        name="name"
        rules={[{ required: true, message: t("settings.required_template_name") }]}
      >
        <Input placeholder={t("settings.templates_placeholders_name")} />
      </LabeledField>
    </div>
  )
}

TemplateForm.propTypes = {}
